import React, { useEffect, useState } from "react";
import Select from "react-select";
import Feild from "./feild";
import { reportUrlGenerator } from "../../utils/reportUrlGenerator";
import { API } from "../../service/api";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const createOption = (label) => ({
  label,
  value: label,
});

const defaultValue = [{ id: 1, key: "", value: "" }];

const EditReport = () => {
  const { state } = useLocation();

  const [reportName, setReportName] = useState(state?.report.report_name || "");
  const [reportHeading, setReportHeading] = useState(
    state?.report.report_heading || ""
  );
  const [reportSubheading, setReportSubheading] = useState(
    state?.report.report_subheading || ""
  );
  const [reportFooter, setReportFooter] = useState(
    state?.report.report_footer || ""
  );

  // columns

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(columns);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setColumns(items);
  }

  const [reportSource, setReportSource] = useState(
    state?.report.report_source || ""
  );

  // const [inputColumn, setInputColumn] = useState("");
  const [columns, setColumns] = useState(
    JSON.parse(state?.report.output_feilds) || defaultValue
  );

  // ordering

  const [orderList, setOrderList] = useState(
    ["asc", "desc"].map((order) => createOption(order))
  );
  const [orderBy, setOrderBy] = useState(
    createOption(state?.report.orderBy) || orderList[0]
  );

  const [sortList, setSortList] = useState(
    JSON.parse(state?.report.output_feilds) || []
  );
  const [sortBy, setSortBy] = useState(
    createOption(state?.report.sortBy) || {}
  );

  // filters
  const [filters, setFilters] = useState(
    JSON.parse(state?.report.report_filters) || defaultValue
  );

  const navigate = useNavigate();

  const onChangeKey = ({ newValue, id }) => {
    setFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.id == id) {
          return { ...filter, key: newValue };
        }
        return filter;
      })
    );
  };
  const onChangeValue = ({ newValue, id }) => {
    setFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.id == id) {
          return { ...filter, value: newValue };
        }
        return filter;
      })
    );
  };

  const onRemoveFilter = (id) => {
    setFilters((prevFilters) =>
      prevFilters.filter((filter) => filter.id != id)
    );
  };

  const handleAddFilters = () => {
    let id = filters[filters.length - 1]?.id;

    setFilters((prev) => [...prev, { id: id + 1, key: "", value: "" }]);
  };

  // columns
  const onChangeColumnKey = ({ newValue, id }) => {
    setColumns((prevCols) =>
      prevCols.map((col) => {
        if (col.id == id) {
          return { ...col, key: newValue };
        }
        return col;
      })
    );
  };
  const onChangeColumnValue = ({ newValue, id }) => {
    setColumns((prevCols) =>
      prevCols.map((col) => {
        if (col.id == id) {
          return { ...col, value: newValue };
        }
        return col;
      })
    );
  };

  const onBlurColumn = () => {
    setSortList(columns.map((col) => createOption(col["value"])));
  };

  const onRemoveColumn = (id) => {
    setColumns((prevCols) => prevCols.filter((col) => col.id != id));

    setSortList(columns.map((col) => createOption(col["value"])));
  };

  const handleAddColumn = () => {
    const columnIds = columns.map((col) => col.id).sort((a, b) => a - b);

    const biggestId = columnIds[columnIds.length - 1];

    const newId = biggestId ? biggestId + 1 : 1;

    const newColumn = { id: newId, key: "", value: "" };
    setColumns((prevColumns) => [...prevColumns, newColumn]);
  };

  // ordering

  //handleSaveReport

  const handleSaveReport = async (e) => {
    e.preventDefault();
    let reportUrl = reportUrlGenerator({
      reportSource,
      filters,
      columns,
      sortBy,
      // orderBy,
    });
    let data = {
      report_name: reportName,
      report_heading: reportHeading,
      report_subheading: reportSubheading,
      report_filters: JSON.stringify(filters),
      company_id: localStorage.getItem("companyId"),
      output_feilds: JSON.stringify(columns),
      sortBy: sortBy["value"] === "" ? columns[0].value : sortBy["value"],
      orderBy: orderBy["value"],
      report_url: reportUrl,
      report_footer: reportFooter,
      report_source: reportSource,
    };

    try {
      const res = await API.putReport(state?.report.id, data);

      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
    } catch (error) {
      showErrorToast(error);
    }
    navigate("/admin/client-detail/reports");
  };

  // useEffect(() => {}, [filters.length]);

  useEffect(() => {
    setSortList(columns.map((col) => createOption(col["value"])));
  }, [columns.length]);

  useEffect(() => {
    const sortListValues = sortList.map((obj) => obj.value);
    let isExisted = sortListValues.includes(sortBy["value"]);

    if (!isExisted) {
      setSortBy({ label: "", value: "" });
    }
  }, [sortList]);

  return (
    <div>
      <div className="">
        <form onSubmit={handleSaveReport} className="">
          {/* Report Metadata */}
          <h2 className="text-xl  font-bold">Report's detail</h2>
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Report Name
              </label>
            </div>
            <div className="sm:col-span-2 sm:mt-0">
              <input
                required
                name="report_name"
                value={reportName}
                onChange={(e) => {
                  setReportName(e.target.value);
                }}
                type="text"
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="name..."
              />
            </div>
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Report Heading
              </label>
            </div>
            <div className="sm:col-span-2 sm:mt-0">
              <input
                required
                name="report_heading"
                value={reportHeading}
                onChange={(e) => {
                  setReportHeading(e.target.value);
                }}
                type="text"
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="heading..."
              />
            </div>
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Report Sub-heading
              </label>
            </div>
            <div className="sm:col-span-2 sm:mt-0">
              <input
                required
                name="report_subheading"
                value={reportSubheading}
                onChange={(e) => {
                  setReportSubheading(e.target.value);
                }}
                type="text"
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="subheading..."
              />
            </div>
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Report Footer
              </label>
            </div>
            <div className="sm:col-span-2 sm:mt-0">
              <input
                required
                name="report_footer"
                value={reportFooter}
                onChange={(e) => {
                  setReportFooter(e.target.value);
                }}
                type="text"
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="footer..."
              />
            </div>
          </div>
          <div className="m-3"></div>
          <h2 className="text-xl  font-bold">Data's detail</h2>
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Data Source
              </label>
            </div>
            <div className="sm:col-span-2 sm:mt-0">
              <input
                required
                name="report_source"
                value={reportSource}
                onChange={(e) => {
                  setReportSource(e.target.value);
                }}
                type="text"
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="source..."
              />
            </div>
          </div>
          {/* filters */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Data Filters
              </label>
            </div>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <div className="overflow-auto max-h-40">
                {filters.map((filter, index) => (
                  <Feild
                    key={filter.id}
                    defaultValues={filter}
                    handlers={[onChangeKey, onChangeValue, onRemoveFilter]}
                    config={"filter"}
                    index={index}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-2 sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0"></div>
            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className="-mt-4 block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm  text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={() => {
                    handleAddFilters();
                  }}
                >
                  Add More Filter
                </button>
                {filters.length > 1 ? (
                  <span>{filters.length} filter added.</span>
                ) : (
                  <span></span>
                )}
              </div>
            </div>
          </div>

          {/* Columns */}

          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Data Columns
              </label>
              <div className="text-blue-500">
                You can arrange the columns in any order by grabing it and
                releasing at a specific location in the list.
              </div>
            </div>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <div className="overflow-auto max-h-40">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="columns">
                    {(provided) => (
                      <ul {...provided.droppableProps} ref={provided.innerRef}>
                        {columns.map((col, index) => (
                          <Draggable
                            key={`data-column-${col.id}`}
                            draggableId={`data-column-${col.id}`}
                            index={index}
                          >
                            {(provided) => (
                              <li
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <Feild
                                  index={index}
                                  defaultValues={col}
                                  handlers={[
                                    onChangeColumnKey,
                                    onChangeColumnValue,
                                    onRemoveColumn,
                                    onBlurColumn,
                                  ]}
                                  config={"column"}
                                />
                              </li>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </div>
          <div className="mt-2 sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0"></div>
            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className="-mt-4 block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm  text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={() => {
                    handleAddColumn();
                  }}
                >
                  Add More Columns
                </button>
                {columns.length > 1 ? (
                  <span>{columns.length} Column added.</span>
                ) : (
                  <span></span>
                )}
              </div>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <div className="mt-1 sm:col-span-1 sm:mt-0">
              <label className="text-base font-semibold text-gray-600">
                Sort By
              </label>
            </div>
            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <div className="sm:grid sm:grid-cols-6 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
                <div className="sm:col-span-5">
                  <Select
                    required
                    isMulti={false}
                    name="sortby"
                    value={sortBy}
                    options={sortList}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(e) => setSortBy(e)}
                  />
                </div>

                <div className="sm:col-span-1 sm:mt-0">
                  <Select
                    value={orderBy}
                    options={orderList}
                    onChange={(e) => {
                      setOrderBy(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5 items-end">
            <div className="mt-1 sm:col-span-2 sm:mt-0"></div>
            <div className="mt-1 sm:col-span-1 sm:mt-0 flex gap-3">
              <button
                type="button"
                className="w-full rounded-md border border-transparent bg-gray-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                onClick={() => {
                  setColumns(defaultValue);
                  setFilters(defaultValue);
                  setSortList([]);
                  setOrderList([]);
                  setSortBy([]);
                  setOrderBy("");
                  setReportName("");
                  setReportHeading("");
                  setReportSubheading("");
                  setReportFooter("");

                  navigate("/admin/client-detail/reports");
                }}
              >
                Discard Report
              </button>
              <button
                type="submit"
                className="w-full rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
              >
                Save Report
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditReport;
